import { render } from "./MultiArtworkModal.vue?vue&type=template&id=6596ee3b&scoped=true"
import script from "./MultiArtworkModal.vue?vue&type=script&lang=js"
export * from "./MultiArtworkModal.vue?vue&type=script&lang=js"

import "./MultiArtworkModal.vue?vue&type=style&index=0&id=6596ee3b&scoped=true&lang=scss"
import "./MultiArtworkModal.vue?vue&type=style&index=1&id=6596ee3b&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.7.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6596ee3b"]])

export default __exports__